import React, { useState, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useWindowSize } from '@react-hook/window-size';

import { useTheme } from '../../ThemeContext';

import ProfileManage from '../ProfileManage';

import {
  Holder,
  Button,
  Name,
  AvatarHolder,
  AvatarPlaceholder,
  Avatar,
  Content,
  Item,
} from './Profile.style';

import { signOut } from '../../actions/Auth/AuthActions';

import { Breakpoints } from '../../assets/Variables.style';

const Profile = () => {
  const [width] = useWindowSize();
  const intl = useIntl();
  const theme = useTheme();
  const [openProfile, setOpenProfile] = useState(false);
  const [visibleProfile, setVisibleProfile] = useState(false);
  const contentRef = useRef();
  const dispatch = useDispatch();
  const firebaseStore = useSelector((state) => state.firebase);
  const { profile } = firebaseStore;
  const [visibleProfileModal, setVisibleProfileModal] = useState(false);

  const useOutsideClick = (ref, callback) => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        callback();
      }
    };

    useEffect(() => {
      document.addEventListener('click', handleClick);

      return () => {
        document.removeEventListener('click', handleClick);
      };
    });
  };

  const handleToggleProfile = () => {
    if (!openProfile) {
      setOpenProfile(true);
      setVisibleProfile(true);
    } else {
      setOpenProfile(false);
      setTimeout(() => {
        setVisibleProfile(false);
      }, 100);
    }
  };

  const handleUserProfileOpen = () => {
    setVisibleProfileModal(true);
  };

  const handleUserProfileClose = () => {
    setVisibleProfileModal(false);
  };

  const handleLogout = () => {
    dispatch(signOut());
  };

  useOutsideClick(contentRef, () => {
    if (openProfile) {
      setOpenProfile(false);
      setTimeout(() => {
        setVisibleProfile(false);
      }, 100);
    }
  });

  return (
    <>
      <Holder ref={contentRef}>
        <Button
          onClick={() => {
            handleToggleProfile();
          }}
        >
          {width > Breakpoints.lg && profile.full_name ? (
            <Name
              theme={theme.profile.name}
              onClick={() => {
                handleToggleProfile();
              }}
            >
              {profile.full_name}
            </Name>
          ) : (
            ''
          )}
          <AvatarHolder
            theme={theme.profile.avatarHolder}
            title={
              profile.full_name
                ? `${profile.full_name}, ${profile.email}`
                : profile.email
            }
          >
            {profile.avatar ? (
              <Avatar
                theme={theme.profile.avatar}
                src={profile.avatar}
                alt={
                  profile.full_name
                    ? `${profile.full_name}, ${profile.email}`
                    : profile.email
                }
              ></Avatar>
            ) : (
              <AvatarPlaceholder theme={theme.profile.avatar} />
            )}
          </AvatarHolder>
        </Button>
        <Content
          theme={theme.profile.content}
          visible={visibleProfile ? true : undefined}
          open={openProfile ? true : undefined}
          close={!openProfile ? true : undefined}
        >
          <Item
            onClick={() => {
              handleUserProfileOpen();
              handleToggleProfile();
            }}
            theme={theme.profile.item}
          >
            {intl.formatMessage({ id: 'PROFILE.USER_PROFILE' })}
          </Item>
          <Item
            theme={theme.profile.item}
            onClick={() => {
              handleLogout();
            }}
          >
            {intl.formatMessage({ id: 'PROFILE.SIGN_OUT' })}
          </Item>
        </Content>
      </Holder>
      {visibleProfileModal && (
        <ProfileManage
          handleClose={() => {
            handleUserProfileClose();
          }}
        />
      )}
    </>
  );
};

export default Profile;
